<div class="ad-step1">
    <div class="container">
        <div class="level-bar pt-5 pb-5">
            <div class="half-line level-bar-active"></div>
            <div class="level level-bar-active">1</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">2</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">3</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">4</div>
            <div class="full-line"></div>
            <div class="level">5</div>
            <div class="full-line"></div>
            <div class="level"><img src="assets/check-red.png" style="width: 26px; height: auto" alt=""></div>
            <div class="full-line"></div>
        </div>
        <div class="level-text">
            Step 4 of 5
        </div>
        <div class="page-contents">
            <div class="heading">
                <h1>Upload images of your property</h1>
                <p>5 steps to post ad of your property.</p>
            </div>
            <div class="form-contents">
                <h3>Property images</h3>
                <p style="font-size: 16px; line-height: 1.5;">Please make sure the images you upload do not exceed 8mb in size. Pictures greater than 8mb will get rejected by the system.</p>
                <form action='#'>
                    <div class="row pt-5">
                        <div class="col-md-6 col-sm-12 mb-4">
                            <h4>Project Gallery</h4>
                            <div class="area">
                                <input type="file" (change)="onGalleryImageChange($event)" multiple accept=".jpg, .png, .jpeg|image/*" />
                                <label for="gallery">
                                    <img src="assets/upload.png"><br>Drag and drop files<br>OR<br>
                                    <div class="button-inside">Browse</div>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12 mb-4" *ngIf="galleryImagesPhotoPaths.length > 0">
                            <h4>Preview Images</h4>
                            <div class="area preview-image row m-1">
                                <div class="delete-holder col-sm-4" *ngFor="let image of galleryImagesPhotoPaths">
                                    <div class="minus" (click)="removeFromGallery(image.name)">
                                        <mat-icon>remove</mat-icon>
                                    </div>
                                    <div class="minus favorite" (click)="setAsMainImage(image.name)">
                                        <mat-icon>star</mat-icon>
                                    </div>
                                    <img class="gallery-image" [src]="image.imagePath" />
                                </div> 
                            </div>
                            <p style="font-size: medium; text-align: left; line-height: 1.8; font-weight: bold;" class="py-4 pr-4">The highlighted image will be the featured image of this Ad and will be displayed at the front. </p>
                        </div>
                    </div>
                    <div class="row justify-content-between pt-5 px-3">
                        <button (click)="previous()">← &nbsp;&nbsp;&nbsp; Previous Step</button>
                        <button (click)="next()">Next Step &nbsp;&nbsp;&nbsp;→</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
